import { render, staticRenderFns } from "./IgnoredStep.vue?vue&type=template&id=b06ee756"
import script from "./IgnoredStep.vue?vue&type=script&lang=js"
export * from "./IgnoredStep.vue?vue&type=script&lang=js"
import style0 from "./IgnoredStep.vue?vue&type=style&index=0&id=b06ee756&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports